import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-memory-thumb-card',
  templateUrl: './memory-thumb-card.component.html',
  styleUrls: ['./memory-thumb-card.component.css']
})
export class MemoryThumbCardComponent implements OnInit {

  @Input() cardID: number;
  @Input() cardTitle: any;
  @Input() memoryData: any = [];
  @Input() isFromMyLibrary:any;
  @Input() isFromMyHistory:any;
  noOfViews: any;
  constructor(public selfLearnService: SelfLearnService, public router:Router) { }

  ngOnInit(): void {
    console.log('memoryData',this.memoryData);
    this.noOfViews = this.getNoOfViews();
  }

  displayTime(duration: any) {
    return this.selfLearnService.secondsToTime(duration);
  }

  getNoOfViews() {
    return this.selfLearnService.generateRandomNumber();
  }

  displayImage(url: any) {
    return url?.replaceAll('https', 'http');
  }
  goToMemoryCards(){
    
    localStorage.setItem('chapterId',this.memoryData.chapterId);
    localStorage.setItem('previousScreen', !this.isFromMyLibrary ?this.isFromMyHistory ? 'selfLearn-V2/my-history' :'selfLearn-V2/bookmarks': 'selfLearn-V2/my-library')
    localStorage.setItem('memoryCardQuestionId',this.memoryData.id);
    this.router.navigate([`selfLearn-V2/memory-card`]);
  }

}
